import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UserProfileService, AvailableFeature } from '../services/user-profile.service';

@Injectable({
  providedIn: 'root'
})
export class DevicesGuard  {

  constructor(
    private userProfileService: UserProfileService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.userProfileService.userProfile) {
      // No profile yet (still signing in, or it failed to load): block without the 404 page.
      return this.userProfileService.ensureUserProfile().then(() => {
        return this.userProfileService.userProfile ? this.checkDeviceManagementFeature() : false;
      });
    } else {
      return this.checkDeviceManagementFeature();
    }
  }

  private checkDeviceManagementFeature(): boolean {
    if (this.userProfileService.isFeatureEnabled(AvailableFeature.DeviceManagement)) {
      return true;
    }

    this.router.navigate(['/404']);
    return false;
  }
}
